import { Box, Grid } from '@mui/material';
import { FC, useCallback, useState } from 'react';
import { DeliveriesFilters } from 'api/models/Deliveries';
import Page from 'components/Page';
import { PageHeader } from 'components/PageHeader';
import { ReceiveDeliveryDialog } from 'components/ReceiveDeliveryDialog/ReceiveDeliveryDialog';
import SearchInput from 'components/SearchInput';
// import SearchInput from 'components/SearchInput';
import { useLanguage } from 'context/AppContext';
import { useActionItemsFilters } from './components/ActionItems/hooks/useActionItemsFilters';
import OverdueCheckInDeliveriesTable from './components/ActionItems/OverdueCheckInDeliveriesTable';
import OverdueCheckOutDeliveriesTable from './components/ActionItems/OverdueCheckOutDeliveriesTable';
import OverdueReceiveDeliveriesTable from './components/ActionItems/OverdueReceiveDeliveriesTable';
import { SearchFiltersBox, SearchInputGrid } from './styles';

export enum TableTypes {
  DEFAULT = 'DEFAULT',
  RECEIVE_OVERDUE = 'RECEIVE_OVERDUE',
  CHECK_IN_OVERDUE = 'CHECK_IN_OVERDUE',
  CHECK_OUT_OVERDUE = 'CHECK_OUT_OVERDUE',
  ALL = 'ALL',
}

const dateToday = new Date();
const day = dateToday.toLocaleDateString('en-GB', { day: 'numeric' });
const month = dateToday.toLocaleDateString('en-GB', { month: 'long' });
const year = dateToday.toLocaleDateString('en-GB', { year: 'numeric' });
const weekday = dateToday.toLocaleDateString('en-GB', { weekday: 'short' });
const dateTodayString = `${day} ${month} ${year} (${weekday})`;

const ActionItemsPage: FC = () => {
  const lang = useLanguage()[0].ActionItemsPage;

  const [receiveDeliveryDialogDeliveryId, setReceiveDeliveryDialogDeliveryId] = useState<number | undefined>(); // used for existing deliveries
  const [isReceiveDeliveryDialogOpen, setIsReceiveDeliveryDialogOpen] = useState(false);

  const [filters, setFilters] = useActionItemsFilters();
  const [expandedTable, setExpandedTable] = useState<TableTypes>(TableTypes.DEFAULT);

  const handleToggleExpand = useCallback((tableType: TableTypes) => {
    setExpandedTable(prev => (prev === tableType ? TableTypes.DEFAULT : tableType));
  }, []);

  // quietly update the filters and invoke a data search
  const updateFilters = useCallback(
    (filters: DeliveriesFilters) => {
      setFilters(filters);
    },
    [setFilters],
  );

  const handleSearch = useCallback(
    async (search: string) => {
      if (search !== filters.search) {
        await updateFilters({ ...filters, search });

        if (search.trim()) {
          setExpandedTable(TableTypes.ALL);
        } else {
          setExpandedTable(TableTypes.DEFAULT);
        }
      }
    },
    [filters, updateFilters],
  );

  return (
    <Page>
      <PageHeader title={lang.title} />
      <Box>Date Today: {dateTodayString}</Box>
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <SearchFiltersBox>
          <SearchInputGrid container>
            <Grid item sx={{ flex: 1, paddingTop: '10px' }}>
              <SearchInput value={filters.search} onChange={handleSearch} />
            </Grid>
          </SearchInputGrid>
        </SearchFiltersBox>
        <OverdueReceiveDeliveriesTable expandedTable={expandedTable} handleToggleExpand={handleToggleExpand} />
        <OverdueCheckInDeliveriesTable expandedTable={expandedTable} handleToggleExpand={handleToggleExpand} />
        <OverdueCheckOutDeliveriesTable expandedTable={expandedTable} handleToggleExpand={handleToggleExpand} />
      </Box>

      {isReceiveDeliveryDialogOpen && (
        <ReceiveDeliveryDialog
          deliveryId={receiveDeliveryDialogDeliveryId}
          onClose={() => {
            setReceiveDeliveryDialogDeliveryId(undefined);
            setIsReceiveDeliveryDialogOpen(false);
          }}
        />
      )}
    </Page>
  );
};

export default ActionItemsPage;
